"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decodeData = decodeData;
exports.decodeIss = decodeIss;
exports.decodeJSON = decodeJSON;
exports.decodeJWT = decodeJWT;
exports.decodeSig = decodeSig;
exports.encodeData = encodeData;
exports.encodeIss = encodeIss;
exports.encodeJSON = encodeJSON;
exports.encodeJWT = encodeJWT;
exports.encodeSig = encodeSig;

var _concat = require("uint8arrays/concat");

var _toString = require("uint8arrays/to-string");

var _fromString = require("uint8arrays/from-string");

var _safeJson = require("@walletconnect/safe-json");

var _constants = require("./constants");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function decodeJSON(str) {
  return (0, _safeJson.safeJsonParse)((0, _toString.toString)((0, _fromString.fromString)(str, _constants.JWT_ENCODING), _constants.JSON_ENCODING));
}

function encodeJSON(val) {
  return (0, _toString.toString)((0, _fromString.fromString)((0, _safeJson.safeJsonStringify)(val), _constants.JSON_ENCODING), _constants.JWT_ENCODING);
}

function encodeIss(publicKey) {
  var header = (0, _fromString.fromString)(_constants.MULTICODEC_ED25519_HEADER, _constants.MULTICODEC_ED25519_ENCODING);
  var multicodec = _constants.MULTICODEC_ED25519_BASE + (0, _toString.toString)((0, _concat.concat)([header, publicKey]), _constants.MULTICODEC_ED25519_ENCODING);
  return [_constants.DID_PREFIX, _constants.DID_METHOD, multicodec].join(_constants.DID_DELIMITER);
}

function decodeIss(issuer) {
  var _issuer$split = issuer.split(_constants.DID_DELIMITER),
      _issuer$split2 = _slicedToArray(_issuer$split, 3),
      prefix = _issuer$split2[0],
      method = _issuer$split2[1],
      multicodec = _issuer$split2[2];

  if (prefix !== _constants.DID_PREFIX || method !== _constants.DID_METHOD) {
    throw new Error("Issuer must be a DID with method \"key\"");
  }

  var base = multicodec.slice(0, 1);

  if (base !== _constants.MULTICODEC_ED25519_BASE) {
    throw new Error("Issuer must be a key in mulicodec format");
  }

  var bytes = (0, _fromString.fromString)(multicodec.slice(1), _constants.MULTICODEC_ED25519_ENCODING);
  var type = (0, _toString.toString)(bytes.slice(0, 2), _constants.MULTICODEC_ED25519_ENCODING);

  if (type !== _constants.MULTICODEC_ED25519_HEADER) {
    throw new Error("Issuer must be a public key with type \"Ed25519\"");
  }

  var publicKey = bytes.slice(2);

  if (publicKey.length !== _constants.MULTICODEC_ED25519_LENGTH) {
    throw new Error("Issuer must be a public key with length 32 bytes");
  }

  return publicKey;
}

function encodeSig(bytes) {
  return (0, _toString.toString)(bytes, _constants.JWT_ENCODING);
}

function decodeSig(encoded) {
  return (0, _fromString.fromString)(encoded, _constants.JWT_ENCODING);
}

function encodeData(params) {
  return (0, _fromString.fromString)([encodeJSON(params.header), encodeJSON(params.payload)].join(_constants.JWT_DELIMITER), _constants.DATA_ENCODING);
}

function decodeData(data) {
  var params = (0, _toString.toString)(data, _constants.DATA_ENCODING).split(_constants.JWT_DELIMITER);
  var header = decodeJSON(params[0]);
  var payload = decodeJSON(params[1]);
  return {
    header: header,
    payload: payload
  };
}

function encodeJWT(params) {
  return [encodeJSON(params.header), encodeJSON(params.payload), encodeSig(params.signature)].join(_constants.JWT_DELIMITER);
}

function decodeJWT(jwt) {
  var params = jwt.split(_constants.JWT_DELIMITER);
  var header = decodeJSON(params[0]);
  var payload = decodeJSON(params[1]);
  var signature = decodeSig(params[2]);
  var data = (0, _fromString.fromString)(params.slice(0, 2).join(_constants.JWT_DELIMITER), _constants.DATA_ENCODING);
  return {
    header: header,
    payload: payload,
    signature: signature,
    data: data
  };
}